export function OutlineImplementacionIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.9 5.63714C10.32 7.36714 9.42 8.98714 8 9.64714V10.4971C8 11.3271 7.33 11.9971 6.5 11.9971C5.67 11.9971 5 11.3271 5 10.4971V9.64714C3.82 9.09714 3 7.88714 3 6.49714C3 4.30714 5.02 2.58714 7.29 3.08714C8.55 3.36714 9.59 4.37714 9.9 5.63714Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 14.0371H15L13 17.4971L15 20.9571H19L21 17.4971L19 14.0371Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6.99805H7"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="17"
        cy="17.5"
        r="0.5"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.99 9.99805V6.99805C18.99 5.89805 18.09 4.99805 16.99 4.99805H14"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 15.998V16.748C5 17.848 5.9 18.748 7 18.748H8.66"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
